'use strict';

const $ = window.jQuery;

export default class FacetWP {
    constructor() {
        $(document).on({
            'facetwp-refresh': function() {
                $('.facetwp-template').addClass('is-loading');
            },

            'facetwp-loaded': function() {
                $('.facetwp-template').removeClass('is-loading');
                $('.facetwp-type-monthly').find('select').select2({
                    language: 'fr',
                    width: '100%',
                    theme: 'primx'
                }).on('select2:open', function () {
                    $('.select2-results__options').niceScroll({
                        cursorcolor: '#333',
                        cursorborder: '0',
                        cursorborderradius: '0'
                    });
                });
            }
        });

        if (typeof FWP !== 'undefined'){
            FWP.loading_handler = function() { }
        }
    }
}
